<div class="field-group"
     [class.origami-updated]="isUpdatedByOrigami"
>
  <p-iftalabel class="w-full">
    @if (control(); as ctrl) {
      <p-datepicker appendTo="body"
                    class="w-full"
                    [formControl]="ctrl"
                    [id]="inputId()"
      />
    }
    <label class="block font-medium mb-1"
           [for]="inputId()"
    >{{ label() }}</label>
  </p-iftalabel>
  @if (showRequiredHint) {
    <small class="block text-red-500 text-xs mt-1">{{ label() }} is required.</small>
  }
</div>
